module.exports = __webpack_public_path__ + "img/pastel-scheme.43059534.png";